import { render, staticRenderFns } from "./SysCertificateMrcCodeForm.vue?vue&type=template&id=01a879f7&"
import script from "./SysCertificateMrcCodeForm.vue?vue&type=script&lang=js&"
export * from "./SysCertificateMrcCodeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01a879f7')) {
      api.createRecord('01a879f7', component.options)
    } else {
      api.reload('01a879f7', component.options)
    }
    module.hot.accept("./SysCertificateMrcCodeForm.vue?vue&type=template&id=01a879f7&", function () {
      api.rerender('01a879f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/SysCertificateMrcCodeForm.vue"
export default component.exports